/* eslint-disable react/self-closing-comp */
import { h, Component } from 'preact';
import { newRelicJSError } from '../analytics/new_relic_helper';
import { unlockBodyPos } from '../helpers/bodyScroll';

export default class NMUserLogin extends Component {
  constructor() {
    super();
    this.state = {
      announcementDontShowAgain: false,
      announcementIsActive: true,
      loginError: false,
      username: undefined,
      password: undefined,
    };
  }

  componentWillMount() {
    // Get data from localStorage to see if the user chose to hide the announcement component
    try {
      if (localStorage.getItem('showAnnouncement') === 'false') {
        this.setState({ announcementIsActive: false });
      }
    } catch (error) {
      console.log(`localStorage getItem failed with error ${error}`);
      newRelicJSError(error);
    }
  }

  componentDidMount() {
    // if the user clicks escape, the modal will close
    window.addEventListener('keydown', (e) => {
      if ((e.key === 'Escape') || (e.key === 'Esc')) {
        this.closeLogin();
      }
    });
    // create array of tabbing elements to create a tabbing cycle that keeps you inside the modal
    const focusItems = this.loginComponent.querySelectorAll('.js-login-focus-item');
    for (let i = 0; i < focusItems.length; i++) {
      this.addFocusListeners(focusItems[i], i, focusItems);
    }
    this.overlay.addEventListener('click', (e) => {
      this.closeLogin();
    });
  }

  addFocusListeners(el, i, focusItems) {
    el.addEventListener('keydown', (e) => {
      if (((e.key === 'Tab') && (!e.shiftKey)) && (i === (focusItems.length - 1))) {
        e.preventDefault();
        focusItems[0].focus();
      }
      if ((e.shiftKey && e.key === 'Tab') && (i === 0)) {
        e.preventDefault();
        focusItems[focusItems.length - 1].focus();
      }
    });
  }

  closeLogin = () => {
    // Using the .remove method instead of using state because the nm_mobile_login_button component is adding the is-active class to this component in order to display it. This was a simpler way of achieving the functionality without having to implement the context API or Redux.
    unlockBodyPos();
    this.loginComponent.classList.remove('is-active');
  }

  hideAnnouncement = () => {
    this.setState({ announcementIsActive: false });
    // Set data in localStorage so the banner stays hidden for this user
    try {
      localStorage.setItem('showAnnouncement', false);
    } catch (error) {
      console.log(`localStorage setItem failed with error ${error}`);
      newRelicJSError(error);
    }
  }

  closeMenuOnKeydown (e) {
    if ((e.key === 'Enter') || (e.key === 'ArrowDown') || (e.key === 'Space')) {
      this.closeLogin();
    }
  }

  // As long as the input names match the state, this will be the appropriate input value to the appropriate state
  handleInputChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  }

  validateForm = (e) => {
    e.preventDefault();
    if (!this.state.username || !this.state.password) {
      this.setState({ loginError: true });
    } else {
      this.setState({ loginError: false });
      this.formEl.submit();
    }
  }

  render() {
    return (
      <div class='nm-user-login' id='nmx-login-component' ref={(el) => { this.loginComponent = el; }}>
        <div class='overlay' id='nm-login-overlay' ref={(el) => { this.overlay = el; }}></div>
        <div class='window' id='nmx-login-window' role='dialog' aria-modal='true'>
          <button class='close-button is-only-on-phone' onClick={this.closeLogin} aria-label='close login window'>
            <img class='close-icon' src='<%=templateBasePath%>/images/close-c.svg' alt='close login modal window' />
          </button>
          <aside class={`announcement ${this.state.announcementIsActive ? 'is-active' : ''}`}>
            <div class='icon-holder'>
              <img src='<%=templateBasePath%>/images/information-word-bubble.svg' class='icon' alt='' />
            </div>
            <h5 class='announcement-header'>Login just got easier.</h5>
            <p class='announcement-text'>Access the following accounts <br class='is-only-on-desktop' /> with a single sign in&#58;</p>
            <ul class='announcement-list'>
              <li class='announcement-list-item'>Personal Insurance &amp; Investments</li>
              <li class='announcement-list-item'>Brokerage &amp; Advisory</li>
              <li class='announcement-list-item'>Trust &amp; Private Client Services</li>
            </ul>
            <button class='announcement-button js-login-focus-item' onClick={this.hideAnnouncement} aria-label='hide this announcement and do not show it again'>Don&#39;t show again</button>
          </aside>
          <div class='main'>
            <button
              class='close-button is-only-on-desktop js-login-focus-item'
              id='user-login-desktop-close-btn'
              onClick={this.closeLogin}
              aria-label='close login window'
            >
              <img class='close-icon' src='<%=templateBasePath%>/images/close-c.svg' alt='x icon' />
            </button>
            <div class='main-wrapper'>
              <h4 class='main-header'>Log in</h4>
              <div class={`error-prompt ${this.state.loginError ? 'is-active' : ''}`}>
                <img class='error-prompt-icon' src='<%=templateBasePath%>/images/error.svg' alt='Error logging in warning icon' />
                <p class={`error-prompt-text ${this.state.loginError ? 'is-active' : ''}`}>Please fill in your Username and Password.</p>
              </div>
              <form
                class='form'
                method='POST'
                ref={(el) => { this.formEl = el; }}
                action='<%=loginPageUrl%>'>
                <fieldset class='login-fieldset'>
                  <legend class='login-legend'>Enter Username and Password.</legend>
                  <label htmlFor='modal-window-nm-login-username' class='input-label'>Username</label>
                  <input
                    class='form-input js-input-first-focus-target js-login-focus-item'
                    id='modal-window-nm-login-username'
                    name='username'
                    type='text'
                    aria-required='true'
                    value={this.state.username}
                    onChange={this.handleInputChange}
                    />
                  <label htmlFor='modal-window-nm-login-password' class='input-label'>Password</label>
                  <input
                    class='form-input js-login-focus-item'
                    id='modal-window-nm-login-password'
                    name='password'
                    type='password'
                    aria-required='true'
                    value={this.state.password}
                    onChange={this.handleInputChange}
                    />
                </fieldset>
                <p class='text'>Forgot <a href='<%=loginPageUrlBase%>/forgot-username' class='form-link js-login-focus-item' aria-label='Retrieve your username.'>username</a> or <a href='<%=loginPageUrlBase%>/password-reset' class='form-link js-login-focus-item' aria-label='Reset your password.'>password</a>&#63;</p>
                <button class='form-submit-button nmx-button js-login-focus-item' type='submit' onclick={this.validateForm}>Log in</button>
                <p class='text centered-desktop'>Don&#39;t have an online account&#63; <a href='<%=loginPageUrlBase%>/registration' class='form-link' aria-label='Register for a new online account.'>Register</a>.</p>
              </form>
            </div>
            <div class='site-links-wrapper'>
              <div class='inner-wrapper'>
                <p class='text'>
                  <span class='block'>Log in to other </span>
                  <span class='block'>Northwestern Mutual sites&#58;</span>
                </p>
                <ul class='other-links-list'>
                  <li class='list-item'><a href='https://www.eaccountservices.com/NM/' class='main-link js-login-focus-item' aria-label='Visit Northwestern Access Fund.'>Access Fund</a></li>
                  <li class='list-item'><a href='https://service2.nml.com/bcis/update/login' class='main-link js-login-focus-item' aria-label='Visit Northwestern Mutual Business Insurance.'>Business Insurance</a></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
